module.exports = __webpack_public_path__ + "static/media/page11_bg.afd9e0af.png";